import { defineComponent } from 'vue'
import classNames from 'classnames'
import './HomeMobileMenu.layout.scss'

export const HomeMobileMenuLayout = defineComponent({
  name: 'HomeMobileMenuLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('home-mobile-menu-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
